import { encyclopediaModifiers } from './encyclopedia.modifiers';
import { encyclopediaSchema } from './encyclopedia.schema';
import { encyclopediaGetters } from './encyclopedia.getters';
import * as encyclopediaRuleset from './encyclopedia.ruleset';
import { encyclopediaActions } from './encyclopedia.actions';
import { ReplicantModuleState } from '../utils';
import { Immutable } from '@play-co/replicant';

export type Encyclopedia = typeof Encyclopedia;
// eslint-disable-next-line no-redeclare
export namespace Encyclopedia {
  export const schema = encyclopediaSchema;
  export const getters = encyclopediaGetters;
  export const modifiers = encyclopediaModifiers;
  export const ruleset = encyclopediaRuleset;
  export const actions = encyclopediaActions;

  export type MutableState = ReplicantModuleState<Encyclopedia>;
  export type State = Immutable<MutableState>;
}
